import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type WorkflowSessionStatus =
  | "started"
  | "processing"
  | "complete"
  | "abandoned"
  | "cancelled";

export type WorkflowSessionRequest = {
  clientId?: string | null;
  workflowTemplateId?: string | null;
  lastActionBy?: string | null;
};

export type WorkflowSessionRelatedCheck = {
  checkId: string;
  type: string;
  taskId: string;
};

export type WorkflowSession = {
  id: string;
  clientId: string;
  entityName: string;
  status: string;
  workflowTemplateId?: string;
  workflowTemplateName?: string;
  workflowTemplateDescription?: string;
  workflowId?: string;
  workflowVersion?: number;
  workflowDescription?: string;
  compliancePolicies?: object[];
  policyAssurance?: object[];
  tasks?: object[];
  lastCompletedTaskId?: string;
  allRelatedChecks?: WorkflowSessionRelatedCheck[];
  outcome?: string;
};

export class WorkflowSessions extends Resource<WorkflowSessionRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("workflowSessions", axiosInstance);
  }

  public async get(id: string): Promise<WorkflowSession> {
    return this.request({ method: Method.GET, path: id });
  }

  public async complete(
    id: string
  ): Promise<{ status: WorkflowSessionStatus }> {
    const path = `${id}/complete`;
    return super.completeSession(path);
  }

  public async list(
    clientId: string,
    workflowTemplateId: string,
    {
      page,
      pageSize
    }: {
      page?: number;
      pageSize?: number;
    } = {}
  ): Promise<WorkflowSession[]> {
    const { items: workflowSessions } = await this.request({
      method: Method.GET,
      query: { clientId, workflowTemplateId, page, pageSize }
    });

    return workflowSessions;
  }
}
